export class ResponseModel {
  constructor(public ok: boolean, public text: string = "") {}

  static create(ok: boolean, text: string = "") {
    return new ResponseModel(ok, text);
  }

  isSuccessful() {
    return this.ok;
  }
}
